import './src/styles/reset.css';
import { navigate } from 'gatsby';

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  if (location?.search && !!prevLocation?.pathname) {
    const slash = prevLocation.pathname.split('').pop('/')
    if(!slash) {
      prevLocation.pathname = `${prevLocation.pathname}/`;
    }
    navigate(`${prevLocation.pathname ? `${prevLocation.pathname}` : '/'}${location.search}`, {replace : true});
    return false;
  }
  return true;
};
